import ScrollAnimation from 'react-animate-on-scroll';
import React from "react";
import Card from '@material-ui/core/Card'
import '../css/projects.css';
import Grid from "@material-ui/core/Grid";
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


const Projects = () => (
    <div id="projects">
        <ScrollAnimation animateIn='fadeInUp' animateOut='fadeOutDown'>
            <h1 className="project-title">Here are some of the things I have worked/am working on...</h1>
            <Grid container>
                <Grid xs={3} className={"grid-options"}>
                    <Card className="card card-left">
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                downloader xl
                            </Typography>
                            <Typography variant="body2" className="text" component="p">
                                A youtube downloader that will also search and add the album
                                cover and metadata (currently private as it is in progress)
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button disableRipple variant="outlined" href="https://github.com/devmarcy/downloader-xl"
                                    size="large" className="bcolor">
                                Github
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid xs={3} className={"grid-options"}>
                    <Card className="card card-left">
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                youtube-desktop
                            </Typography>
                            <Typography variant="body2" className="text" component="p">
                                A desktop web app made from Youtube using Electron's electron-quick-start repo. Also has
                                ad-blocker packaged with it so there are no ads on videos. </Typography>
                        </CardContent>
                        <CardActions>
                            <Button disableRipple variant="outlined" href="https://github.com/devmarcy/youtube-desktop"
                                    size="large" className="bcolor">
                                Github
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid xs={3} className={"grid-options"}>
                    <Card className="card card-left card-mobile">
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                devmarcy.github.io
                            </Typography>
                            <Typography variant="body2" className="text" component="p">
                                A personal website created from the github template. <br/><br/><br/></Typography>
                        </CardContent>
                        <CardActions>
                            <Button disableRipple variant="outlined"
                                    href="https://github.com/devmarcy/devmarcy.github.io"
                                    size="large" className="bcolor">
                                Github
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid xs={3} className={"grid-options"}>
                    <Card className="card card-left card-mobile">
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                offline-gamers
                            </Typography>
                            <Typography variant="body2" className="text" component="p">
                                A game stats text service that returns stats for a player, via varying text commands, for varying games. <br/><br/><br/></Typography>
                        </CardContent>
                        <CardActions>
                            <Button disableRipple variant="outlined"
                                    href="https://github.com/devmarcy/offline-gamers"
                                    size="large" className="bcolor">
                                Github
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>

            </Grid>
        </ScrollAnimation>
    </div>
);
export default Projects;
